export const AVAILABILITY_OPTIONS = ["Weekday mornings", "Weekday evenings", "Weekends", "Flexible"];

// Partner-supported modes
export const PARTNER_MODES = ["In-person", "Virtual", "Both"];
// Member preferred modes
export const MEMBER_MODES = ["In-person", "Virtual", "Either"];
// Discovery filter -> backend mode param
export const FILTER_MODES = ["In-person", "Virtual", "Both"];
